import { ICellRendererParams } from 'ag-grid-community';
import { FunctionComponent } from 'react';
import { TransactionModel } from '../../types/TransactionModel';
import { TransactionType } from '../../api/transactions/transaction.contracts';
import { useTranslation } from '@/lib';

export const TransactionTypeCellRenderer: FunctionComponent<ICellRendererParams<TransactionModel>> = (params) => {
  const { t } = useTranslation();

  if (!params.data) {
    return null;
  }

  const type = params.data.type;

  // Get label based on type
  const getTypeLabel = () => {
    switch (type) {
      case TransactionType.Transfer:
        return t('transfer');
      case TransactionType.Correction:
        return t('correction');
      case TransactionType.System:
        return t('system');
      default:
        return t('unknown');
    }
  };

  // Get color classes based on type
  const getColorClasses = () => {
    switch (type) {
      case TransactionType.Transfer:
        return {
          bg: 'bg-blue-100 dark:bg-blue-500/20',
          text: 'text-blue-800 dark:text-blue-300',
        };
      case TransactionType.Correction:
        return {
          bg: 'bg-red-100 dark:bg-red-500/20',
          text: 'text-red-800 dark:text-red-300',
        };
      case TransactionType.System:
        return {
          bg: 'bg-purple-100 dark:bg-purple-500/20',
          text: 'text-purple-800 dark:text-purple-300',
        };
      default:
        return {
          bg: 'bg-gray-100 dark:bg-gray-500/20',
          text: 'text-gray-800 dark:text-gray-300',
        };
    }
  };

  const colors = getColorClasses();

  return (
    <div className="flex h-full items-center">
      <span className={`inline-flex rounded-md px-3 py-1 mt-1 text-xs font-semibold ${colors.bg} ${colors.text}`}>{getTypeLabel()}</span>
    </div>
  );
};
